import CreteId from './createId';
import scrollTop from './scrollTop';
import GoogleAnalytics from './GoogleAnalytics';

const Helpers = {
	createId: CreteId,
	scrollTop: scrollTop,
	ga: GoogleAnalytics
}

export default Helpers;